import {
  DestroyRef,
  Directive,
  ElementRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, NgControl } from '@angular/forms';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { controlStatus$ } from '../../utils/form-control/form-control.utils';

@Directive({
  selector: '[appFormControl]',
  standalone: true,
})
export class FormControlDirective implements OnInit {
  private control?: AbstractControl | null;
  private readonly elementRef = inject(ElementRef);
  private readonly ngControl = inject(NgControl);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.control = this.ngControl.control;
    if (!this.control) {
      return console.error(
        'appFormDependantControl must be used on an ngControl',
      );
    }

    this.toggleCssClassBasedOnControlProperty('disabled');
    this.toggleCssClassBasedOnControlProperty('enabled');
    this.toggleCssClassBasedOnControlProperty('invalid');
    this.toggleCssClassBasedOnControlProperty('touched');
    this.toggleCssClassBasedOnControlProperty('untouched');
    this.toggleCssClassBasedOnControlProperty('valid');
    this.toggleCssClassBasedOnControlProperty('value', 'has-value');
  }

  private toggleCssClassBasedOnControlProperty(
    property: keyof AbstractControl,
    cssClass?: string,
  ): void {
    controlStatus$(this.control)
      .pipe(
        map(() => this.control && this.control[property]),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((condition: boolean) => {
        this.elementRef.nativeElement.classList.toggle(
          `form-control--${cssClass ?? property}`,
          !!condition,
        );
      });
  }
}
